// Shared `{{placeholder}}` handling for the admin vignette screens.
//
// The pattern itself is NOT defined here — it lives server-side in
// Vignette::VARIABLE_PATTERN and reaches these controllers as a Stimulus value,
// so the grammar has exactly one definition. This module only turns that source
// string into a regex and applies it, so the matching logic isn't duplicated
// per controller either.

// Builds a global regex from the server-supplied pattern source.
export function variableRegex(source) {
  if (!source) {
    throw new Error(
      'Missing vignette variable pattern. Pass Vignette::VARIABLE_PATTERN.source ' +
        'as this controller\'s `pattern` Stimulus value.'
    )
  }

  return new RegExp(source, 'g')
}

// Returns the unique placeholder names in `scenario`, in the order they appear.
export function extractVariableNames(scenario, source) {
  const regex = variableRegex(source)
  const names = []
  let match

  while ((match = regex.exec(scenario)) !== null) {
    const name = match[1].trim()
    if (name && !names.includes(name)) {
      names.push(name)
    }
  }

  return names
}
